import type { RequiredPermissions } from 'types/Permissions';

import { AccessLevel, ResourceType } from 'store/client/graphql';

/*
 * The appraisal builders' permissions live in this leaf module so the appraisal card's selectors can gate on the same
 * grant without importing the builder registry, which would be circular.
 */

/**
 * Sending an invite writes to the trade-in itself.
 */
export const INVITE_APPRAISERS_PERMISSIONS: NonNullable<RequiredPermissions> = [
  { level: AccessLevel.FULL, resource: ResourceType.TRADE_IN_ITEMS },
];

/**
 * Submitting or updating an appraisal writes to the appraisals resource.
 */
export const SUBMIT_APPRAISAL_PERMISSIONS: NonNullable<RequiredPermissions> = [
  { level: AccessLevel.FULL, resource: ResourceType.TRADE_IN_APPRAISALS },
];
